define( [
	"./class2type"
], function( class2type ) {
	"use strict";

	return class2type.toString;
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/var/toString.js
// module id = 497
// module chunks = 0